/**
 * This component maps chart names to actual chart components
 */

import React from 'react'
import injectSize from 'lib/components/charts/inject-size'

class ChartSwitch extends React.PureComponent {
  static defaultProps = {
    chartMap: {}
  }

  render() {
    const {
      expanded,
      query,
      chart,
      chartMap,
      width,
      height,
      title,
      ...dataProps
    } = this.props

    // TODO: make this a nicer view
    if (chart.text in chartMap === false) {
      return null
    }

    const { component, ...props } = chartMap[chart.text]({
      ...dataProps,
      query,
      expanded
    })

    return React.createElement(component, { ...props, width, height, title })
  }
}

export default injectSize(ChartSwitch)



// WEBPACK FOOTER //
// ./src/components/chart-switch.js